// src/components/elements/PillButton.js
import React from 'react';

const PillButton = ({ label, onClick }) => {
  return (
    <button
      className="px-6 py-2 bg-blue-500 text-white rounded-full hover:bg-blue-600 focus:outline-none"
      onClick={onClick}
    >
      {label}
    </button>
  );
};

export default PillButton;
